import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import DashboardTableSection from './DashboardTableSection'
import DashboardSectionHeader from './DashboardSectionHeader'
import { currencyFormatter, percentageFormatter } from '../../../common/utils/helpers';
import Table from 'antd/lib/table';
import { ResponsiveTable } from '../../../common/components/data-display';
import { Tabs } from 'antd';

const { TabPane } = Tabs;

const Column = Table.Column;

@translate()
export default class DashboardTables extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        reportData: PropTypes.object
    };


    render() {
        const {
            reportData,
            t,
        } = this.props;

        const generateTableData = (sectionArray, reportDataSection) => {
            if (!reportData || !reportData[reportDataSection]) {
                return;
            }

            sectionArray.forEach(obj => {
                if (!reportData[reportDataSection][obj.rowKey]) {
                    return;
                }
                let formatData = null
                switch (obj.type) {
                    case "invAct":
                    case "loan":
                        formatData = data => `${data.count} / ${currencyFormatter(data.amount)}`
                        break;
                    case 'inst':
                        formatData = data => `${data.count} / ${currencyFormatter(data.amount.amount)} (${currencyFormatter(data.amount.principalAmount)} / ${currencyFormatter(data.amount.interestAmount)})`
                        break;
                    case 'cred':
                        formatData = data => `${data.count}`
                        break
                    case "bank":
                        formatData = data => `${currencyFormatter(data.amount)}`
                        break
                    case "portQ":
                        formatData = data => {
                            if (data.default) {
                                return `${percentageFormatter(data.countRatio, 2)} / ${percentageFormatter(data.amountRatio, 2)}`
                            } else if (data.amountToPay) {
                                return `${data.count} / ${currencyFormatter(data.amountToPay)}`
                            } else {
                                return `${data.count} / ${currencyFormatter(data.amount)}`
                            }
                        }
                        break
                    case "credLoy":
                        formatData = data => data.ratio ? `${percentageFormatter(data.value, 2)}` : `${data.value}`
                        break
                    case "amount":
                        formatData = data => `${currencyFormatter(data)}`
                        break
                    case "ratio":
                        formatData = data => data == "N/A" ? data : `${percentageFormatter(data, 2)}`
                        break
                    default:
                        break
                }

                for (let columnKey in reportData[reportDataSection][obj.rowKey]) {
                    obj[columnKey] = formatData(reportData[reportDataSection][obj.rowKey][columnKey])
                }
            })
        }


        const activeFinances = [
            { title: 'Suma voľných prostriedkov na účtoch investorov:', rowKey: 'totalCreditorsBalance', value: currencyFormatter(reportData.totalCreditorsAccountBalance) },
            {
                title: 'Žiadosti s otvoreným financovaním (počet / požadovaná / naplnené):', rowKey: 'openLoans', value: `${reportData.approvedLoans.count} / ${currencyFormatter(reportData.approvedLoans.required)} /
                    ${currencyFormatter(reportData.approvedLoans.invested)}`
            },
            {
                title: 'Investori s autoinvestom (počet / suma voľných prostriedkov):', rowKey: 'autoinvestCreditors', value: `${reportData.creditorsAccountBalance.automatic.count} / ${currencyFormatter(reportData.creditorsAccountBalance.automatic.amount)}`
            },
            {
                title: 'Investori bez autoinvestu (počet / suma voľných prostriedkov):', rowKey: 'manualCreditors', value: `${reportData.creditorsAccountBalance.manual.count} / ${currencyFormatter(reportData.creditorsAccountBalance.manual.amount)}`
            }]

        let investorsActivity = [
            { title: 'Nové investície spolu:', rowKey: 'newAllocations', type: "invAct", style: "bold" },
            { title: 'Nové investície cez Autoinvest:', rowKey: 'newAutomaticAllocations', type: "invAct" },
            { title: 'Priemerná suma investície:', rowKey: 'averageAllocationAmount', type: "amount", style: "italic" },
            { title: 'Podiel autoinvestu na investíciách', rowKey: 'automaticAllocationsRatio', type: "ratio", style: "italic" },
            { title: 'Vklady na účet investorov:', rowKey: 'investorsDeposits', type: "invAct", style: "bold" },
            { title: 'Priemerný vklad na účet:', rowKey: 'averageDeposit', type: "amount", style: "italic" },
            { title: 'Výbery z účtu:', rowKey: 'investorsWithdrawals', type: "invAct" }
        ]


        let requestsAndloans = [
            { title: 'Vyplnená kalkulačka:', rowKey: 'initRegDeptors1', type: 'loan' },
            { title: 'Vyplnené osobné údaje:', rowKey: 'initRegDeptors2', type: 'loan' },
            { title: 'Vyplnené kontaktné údaje:', rowKey: 'initRegDeptors3', type: 'loan' },
            { title: 'Začatá žiadosť (neaktívny):', rowKey: 'inactiveDeptors', type: 'loan' },
            { title: 'Potvrdený e-mail:', rowKey: 'emailConfirmedDeptors', type: 'loan' },
            { title: 'Odoslané dokumenty:', rowKey: 'documentSubmittedDeptors', type: 'loan' },
            { title: 'Schválené dokumenty (OP):', rowKey: 'documentAcceptedDeptors', type: 'loan' },
            { title: 'Zaslané výpisy a výplatné pásky:', rowKey: 'sentStatementsAndPayslips', type: 'loan' },
            { title: 'Z toho cez PSD2', rowKey: 'sentStatementsAndPayslipsViaPSD2', type: 'loan', style: 'italic' },
            { title: 'Opakované žiadosti cez PSD2', rowKey: 'sentStatementsAndPayslipsViaPSD2SecondLoans', type: 'loan', style: 'italic' },
            { title: 'Zmluva podpísaná:', rowKey: 'contractSignedDeptors', type: 'loan' },
            { title: 'Pôžička čaká na schválenie:', rowKey: 'requestedLoans', type: 'loan' },
            { title: 'Z toho počet druhých a ďalších od rovnakého dlžníka:', rowKey: 'requestedSecondLoans', type: 'loan', style: "italic" },
            { title: 'Zamietnutá:', rowKey: 'refusedLoans', type: 'loan' },
            { title: 'Zamietnutá v prescoringu' , rowKey: 'refusedInPrescoring', type: 'loan'},
            { title: 'Schválená (hľadáme pre Vás investora):', rowKey: 'approvedLoans', type: 'loan' },
            { title: 'Nenaplnená žiadosť:', rowKey: 'expiredLoans', type: 'loan' },
            { title: 'Zrušená žiadosť:', rowKey: 'canceledLoans', type: 'loan' },
            { title: 'Zrušená žiadosť adminom:', rowKey: 'canceledByAdminLoans', type: 'loan' },
            { title: 'Odstúpenie od Rámcovej zmluvy klientom:', rowKey: 'withdrawnByClientLoans', type: 'loan' },
            { title: 'Aktívna (poskytnutá pôžička):', rowKey: 'activeLoans', type: 'loan', style: "bold" },
            { title: 'Podiel schválených žiadostí zo všetkých:', rowKey: 'approvedLoansRatio', type: 'ratio', style: "italic" },
            { title: 'Podiel schválených žiadostí z kompletných:', rowKey: 'requestedLoansRatio', type: 'ratio', style: "italic" },
            { title: 'Podiel zamietnutých žiadostí z kompletných:', rowKey: 'refusedLoansRatio', type: 'ratio', style: "italic" },
            { title: 'Podiel úspešne financovaných žiadostí zo schválených:', rowKey: 'activeLoansRatio', type: 'ratio', style: "italic" },
            { title: 'Priemerná suma poskytnutej pôžičky:', rowKey: 'averageActiveLoanAmount', type: 'amount', style: "italic" }
        ]

        let installments = [
            { title: 'Splátky splatné:', rowKey: 'all', type: 'inst', style: "bold" },
            { title: 'z toho evidované ako uhradené (podľa splátkového kalendára):', rowKey: 'paid', type: 'inst' },
            { title: 'z toho evidované ako neuhradené (podľa splátkového kalendára):', rowKey: 'unpaid', type: 'inst' },
            { title: 'Inkasný pomer:', rowKey: 'paidInstallmentsRatio', type: 'ratio', style: "italic" },
        ]

        let creditors = [
            { title: 'Začatá registrácia (neaktívny):', rowKey: 'inactive', type: 'cred' },
            { title: 'Potvrdený e-mail:', rowKey: 'emailConfirmed', type: 'cred' },
            { title: 'Nevyplnený profil:', rowKey: 'profileComplete', type: 'cred' },
            { title: 'Odoslané dokumenty:', rowKey: 'documentSubmitted', type: 'cred' },
            { title: 'Schválené dokumenty:', rowKey: 'documentAccepted', type: 'cred' },
            { title: 'Aktívny:', rowKey: 'active', type: 'cred', style: "bold" },
            { title: 'Podiel aktívnych:', rowKey: 'activeCreditorsRatio', type: 'ratio', style: "italic" }
        ]

        let bank = [
            { title: 'Prijaté platby:', rowKey: 'paymentsIn', type: 'bank' },
            { title: 'Odoslané platby:', rowKey: 'paymentsOut', type: 'bank' }
        ]

        const currentYear = (new Date()).getFullYear()
        const startYear = 2018

        let portfolioQuality = []

        for (let year = startYear; year <= currentYear; year++) {
            portfolioQuality.push({
                title: 'Pôžičky poskytnuté v roku ' + year,
                rowKey: 'loans' + year,
                type: 'portQ'
            })
        }

        portfolioQuality.push({ title: 'Poskytnuté pôžičky spolu:', rowKey: 'loansOverall', type: 'portQ', style: "bold" })
        portfolioQuality.push({ title: '% na aktívnych (počet):', rowKey: 'overallActiveRatios', type: 'ratio', style: "italic" })

        let creditorsLoyalty = []
        for (let year = startYear; year <= currentYear; year++) {
            creditorsLoyalty.push({
                title: 'Registrovaní investori v roku ' + year,
                rowKey: 'creditors' + year,
                type: 'credLoy'
            })
        }
        creditorsLoyalty.push({ title: 'Registrovaní investori celkom:', rowKey: 'creditorsOverall', type: 'credLoy', style: "bold" })

        generateTableData(investorsActivity, "investorsActivity")
        generateTableData(requestsAndloans, "loans")
        generateTableData(installments, "installments")
        generateTableData(creditors, "creditors")
        generateTableData(bank, "bank")
        generateTableData(portfolioQuality, "portfolioQuality")
        generateTableData(creditorsLoyalty, "creditorsLoyalty")


        return (
            <div className="admin-dashboard">
                <Tabs type="card">
                    <TabPane tab="Dashboard 1" key="1">
                        <DashboardSectionHeader title={t('AKTÍVNE FINANCOVANIE')} units={t('(Počet (ks) / Suma (€))')} cols="5"></DashboardSectionHeader>
                        <ResponsiveTable dataSource={activeFinances} pagination={false}>
                            <Column
                                title={''}
                                className='dashboard-col-5'
                                dataIndex="title"
                                key="title"
                                render={value => t(value)}
                            />
                            <Column
                                title={t('Stav')}
                                dataIndex="value"
                                key="value"
                            />
                        </ResponsiveTable>

                        <DashboardSectionHeader title={t('AKTIVITA INVESTOROV')} units={t('(Počet (ks) / Suma (€))')} cols="5"></DashboardSectionHeader>
                        <DashboardTableSection t={t} sectionData={investorsActivity}></DashboardTableSection>

                        <DashboardSectionHeader title={t('ŽIADOSTI A PÔŽIČKY')} units={t('(Počet (ks) / Istina (€))')} cols="5"></DashboardSectionHeader>
                        <DashboardTableSection t={t} sectionData={requestsAndloans}></DashboardTableSection>
                    </TabPane>
                    <TabPane tab="Dashboard 2" key="2">
                        <DashboardSectionHeader title={t('SPLÁTKY PÔŽIČIEK')} units={t('(Počet (ks) / Spolu (€) (Istina (€) / Úrok (€)))')} cols="5"></DashboardSectionHeader>
                        <DashboardTableSection t={t} sectionData={installments}></DashboardTableSection>

                        <DashboardSectionHeader title={t('BANKOVÝ ÚČET')} units={t('(Suma (€))')} cols="5"></DashboardSectionHeader>
                        <DashboardTableSection t={t} sectionData={bank}></DashboardTableSection>

                        <DashboardSectionHeader title={t('REGISTRÁCIA INVESTOROV')} units={t('(Počet (ks))')} cols="5"></DashboardSectionHeader>
                        <DashboardTableSection t={t} sectionData={creditors}></DashboardTableSection>

                    </TabPane>
                    <TabPane tab="Dashboard 3" key="3">





                        <DashboardSectionHeader title={t('KVALITA PORTFÓLIA')} units={t('(Počet (ks) / Čistá istina (€))')} cols="5"></DashboardSectionHeader>
                        <ResponsiveTable
                            dataSource={portfolioQuality}
                            rowClassName={(record) => record.style ? `section-row-${record.style}` : ``}
                            pagination={false}>
                            <Column
                                title={''}
                                dataIndex="title"
                                key="title"
                                className='dashboard-col-5'
                                render={value => t(value)}
                            />
                            <Column
                                title={t('Omeškanie < 4 dni')}
                                dataIndex="delay4"
                                key="delay4"
                            />
                            <Column
                                title={t('Omeškanie 5 - 30 dní')}
                                dataIndex="delay30"
                                key="delay30"
                            />
                            <Column
                                title={t('Omeškanie 31 - 60 dní')}
                                dataIndex="delay60"
                                key="delay60"
                            />
                            <Column
                                title={t('Omeškanie > 61 dní')}
                                dataIndex="delayOver61"
                                key="delayOver61"
                            />
                            <Column
                                title={t('Odpredané (defaultné) pôžičky')}
                                dataIndex="disposed"
                                key="disposed"
                            />
                            <Column
                                title={t('Všetky poskytnuté')}
                                dataIndex="activated"
                                key="activated"
                            />
                            <Column
                                title={t('% Default (odpredané / poskytnuté)')}
                                dataIndex="defaultRatio"
                                key="defaultRatio"
                            />
                        </ResponsiveTable>

                        <DashboardSectionHeader title={t('LOJALITA INVESTOROV')} units={t('(Počet (ks) investorov s investíciou)')} cols="5"></DashboardSectionHeader>
                        <ResponsiveTable
                            dataSource={creditorsLoyalty}
                            rowClassName={(record) => record.style ? `section-row-${record.style}` : ``}
                            pagination={false}>
                            <Column
                                title={''}
                                dataIndex="title"
                                key="title"
                                className='dashboard-col-5'
                                render={value => t(value)}
                            />
                            <Column
                                title={t('Posledných 7 dní')}
                                dataIndex="count7Days"
                                key="count7Days"
                            />
                            <Column
                                title={t('Posledných 30 dní')}
                                dataIndex="count30Days"
                                key="count30Days"
                            />
                            <Column
                                title={t('Posledných 90 dní')}
                                dataIndex="count90Days"
                                key="count90Days"
                            />
                            <Column
                                title={t('% z aktívnych')}
                                dataIndex="count90DaysRatio"
                                key="count90DaysRatio"
                            />
                            <Column
                                title={t('Nikdy neinvestoval')}
                                dataIndex="neverInvested"
                                key="neverInvested"
                            />
                            <Column
                                title={t('% z aktívnych')}
                                dataIndex="neverInvestedRatio"
                                key="neverInvestedRatio"
                            />
                            <Column
                                title={t('Všetci aktívni')}
                                dataIndex="allActiveCreditors"
                                key="allActiveCreditors"
                            />
                        </ResponsiveTable>
                    </TabPane>
                </Tabs>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/features/admin-dashboard/components/DashboardTables.js